// Swaps "next-day" for "next working day" in USP titles when an order placed now won't arrive tomorrow.
// Same rules as delivery-eta.js: dispatch today if a working day before the cutoff, arrive the next working day.

const BANK_HOLIDAYS_KEY = 'uk_bank_holidays';
const BANK_HOLIDAYS_EXPIRY_KEY = 'uk_bank_holidays_expiry';

let bankHolidaysPromise;

function getBankHolidays() {
	bankHolidaysPromise ??= (async () => {
		try {
			const cached = localStorage.getItem(BANK_HOLIDAYS_KEY);
			const expiry = localStorage.getItem(BANK_HOLIDAYS_EXPIRY_KEY);
			if (cached && expiry && Date.now() < parseInt(expiry, 10)) return JSON.parse(cached);

			const res = await fetch('https://www.gov.uk/bank-holidays.json');
			const data = await res.json();
			const dates = (data['england-and-wales']?.events || []).map((e) => e.date);
			localStorage.setItem(BANK_HOLIDAYS_KEY, JSON.stringify(dates));
			localStorage.setItem(BANK_HOLIDAYS_EXPIRY_KEY, String(Date.now() + 86400000));
			return dates;
		} catch {
			return [];
		}
	})();
	return bankHolidaysPromise;
}

const dateKey = (d) =>
	`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

class NextDayUsp extends HTMLElement {
	#title;
	#interval;

	connectedCallback() {
		this.#title = this.textContent;
		this.#update();
		// Catches the cutoff passing while the page is open.
		this.#interval = setInterval(() => this.#update(), 60000);
	}

	disconnectedCallback() {
		clearInterval(this.#interval);
	}

	async #update() {
		const { cutoffHour, cutoffMinute, excludedDays, excludeBankHolidays } = this.dataset;
		const excluded = new Set(excludedDays.split(',').filter(Boolean).map(Number));
		const bankHolidays = excludeBankHolidays === 'true' ? await getBankHolidays() : [];
		const isWorkingDay = (d) => !excluded.has(d.getDay()) && !bankHolidays.includes(dateKey(d));

		const now = new Date();
		const cutoff = new Date(now);
		cutoff.setHours(parseInt(cutoffHour, 10) || 0, parseInt(cutoffMinute, 10) || 0, 0, 0);
		const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
		const arrivesTomorrow = isWorkingDay(now) && now < cutoff && isWorkingDay(tomorrow);

		this.textContent = arrivesTomorrow ? this.#title : this.#title.replace('next-day', 'next working day');
	}
}

if (!customElements.get('next-day-usp')) {
	customElements.define('next-day-usp', NextDayUsp);
}
